// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"DrupalSelfReflectNugget__sliderContainer___2VWKa","minImage":"DrupalSelfReflectNugget__minImage___2vF3Z","maxImage":"DrupalSelfReflectNugget__maxImage___37mvm"};